import AuthenticatedLayout from "@/layouts/authenticated";
import { Breadcrumb } from "antd";
import React, { useEffect } from "react";
import BreadcrumbItem from "antd/lib/breadcrumb/BreadcrumbItem";
import { useSelector } from "react-redux";
import { acessoSelector, acessosSelector, fetchAcessos } from "@/store/acessos";
import { empresasSelector, fetchEmpresas } from "@/store/empresas";
import useDispatchWithResult from "@/hooks/useDispatchWithResult";
import { fetchDataAnalyticsDashboard } from "@/store/dataAnalytics";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "@/hooks/useSearchParams";
import DashboardFiltros from "./_DashboardFiltros";
import DashboardScorecards from "./_DashboardScorecards";
import DashboardCharts from "./_DashboardCharts";
import { fetchWorkflows, workflowsSelector } from "@/store/workflows";
import { fetchWorkflowResumoByPeriodo } from "@/store/workflow";

export default function DataAnalyticsDashboardPage() {
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const acessos = useSelector(acessosSelector);
  const acesso = useSelector(acessoSelector);
  const empresas = useSelector(empresasSelector);
  const workflows = useSelector(workflowsSelector);
  let workflowId = workflows?.[0]?.id;
  const acessoId = acesso?.id;
  const [searchParams, setSearchParams] = useSearchParams({});

  useEffect(() => {
    let fetch;
    if (!acessos || !acessos.length) fetch = fetchAcessos({ fetchEmpresas: fetchEmpresas });
    else if (!empresas || !empresas.length) fetch = fetchEmpresas({ acessoId: acessoId, modulo: "" });

    if (!fetch) return;
    dispatch(fetch);

    if (workflows.length !== 0) return;
    dispatch(fetchWorkflows({ acessoId: acessoId })).then((res) => (workflowId = res[0]?.id));
  }, [acessos, acessoId, empresas]);

  useEffect(() => {
    const start = searchParams.get("startDate");
    const end = searchParams.get("endDate");

    if (!start || !end) return;
    dispatch(
      fetchDataAnalyticsDashboard({
        startDate: start,
        endDate: end,
        empresasIds: searchParams.get("empresasIds"),
        acessoId: searchParams.get("acessoId"),
        modulosIds: searchParams.get("modulosNames"),
      })
    );

    if (!workflowId) return;
    dispatch(fetchWorkflowResumoByPeriodo({ workflowId, dataInicial: start, dataFinal: end }));
  }, [searchParams.toString(), workflowId]);

  return (
    <AuthenticatedLayout modulo="data-analytics">
      <>
        <Breadcrumb style={{ marginBottom: 16, fontSize: 14 }}>
          <Breadcrumb.Item>{t("Data Analytics")}</Breadcrumb.Item>
          <BreadcrumbItem>
            <span style={{ fontWeight: "bold" }}>{t("Gestão Corporativa e de Produtividade")}</span>
          </BreadcrumbItem>
        </Breadcrumb>

        <DashboardFiltros onFiltersChange={setSearchParams} />
        <DashboardScorecards />
        <DashboardCharts />
      </>
    </AuthenticatedLayout>
  );
}
